module.exports = __webpack_public_path__ + "static/media/bacchus-og.0365c132.png";